import { useState } from 'react';

import { Grid, Typography } from '@mui/material';
import { Dayjs } from 'dayjs';

import { NPIDateRangePicker } from 'src/components';
import { NPIAutoComplete } from 'src/components/FormikComponents';
import { AutoCompleteOptionType } from 'src/components/FormikComponents/NPIAutoComplete';
import { FilterOptionsType } from 'src/utils/tableUtils';

interface TableFilterProps {
    updateFilters: (newFilter: string, filterValue: string | { from: Dayjs; to: Dayjs }) => void;
    filterOptions: FilterOptionsType;
}

const TableFilter = ({ updateFilters, filterOptions }: TableFilterProps) => {
    const [dateRange, setDateRange] = useState<{
        from: Dayjs | null;
        to: Dayjs | null;
    }>({
        from: null as unknown as Dayjs,
        to: null as unknown as Dayjs,
    });

    return (
        <Grid container spacing={1} alignItems="center">
            {Object.keys(filterOptions).map((filterOption) => {
                const selectOptions = filterOptions[`${filterOption}`];

                return (
                    <Grid item key={filterOption} xs={6}>
                        <Typography fontSize={16} fontWeight={500} my={1} variant="subtitle1">
                            {filterOption}
                        </Typography>
                        {(() => {
                            if (filterOption === 'Date') {
                                return (
                                    <NPIDateRangePicker
                                        defaults={dateRange}
                                        setDate={(date: { from: Dayjs; to: Dayjs }) => {
                                            setDateRange(date);
                                            updateFilters('Date', date);
                                        }}
                                    />
                                );
                            }

                            return (
                                <NPIAutoComplete
                                    name={filterOption}
                                    options={selectOptions as AutoCompleteOptionType[]}
                                    onInputChange={(value) => {
                                        let selectedValue = value;
                                        if (filterOption.toLowerCase() === 'id') {
                                            selectedValue = selectOptions.find(
                                                (selectOption) => selectOption.label === value
                                            )?.value;
                                        }
                                        updateFilters(filterOption, selectedValue);
                                    }}
                                    useFormik={false}
                                />
                            );
                        })()}
                    </Grid>
                );
            })}
        </Grid>
    );
};
export default TableFilter;
